/**
 * AuditLogView — tabla audit log + filtros (admin).
 *
 * Per FWA-PWA-033 G0 D4. Summaries truncados, sin PII raw expuesta.
 */
import { useState } from 'react';
import { Card, CardBody, CardHeader, CardTitle } from '../../components/ui/Card.js';
import { useAuditLogList } from '../../lib/queries/audit.js';

export function AuditLogView() {
  const [eventType, setEventType] = useState<string>('');
  const [actorEmail, setActorEmail] = useState<string>('');
  const [from, setFrom] = useState<string>('');
  const [to, setTo] = useState<string>('');

  const filters: { event_type?: string; actor_email?: string; from?: string; to?: string } = {};
  if (eventType.trim()) filters.event_type = eventType.trim();
  if (actorEmail.trim()) filters.actor_email = actorEmail.trim();
  if (from) filters.from = `${from}T00:00:00Z`;
  if (to) filters.to = `${to}T23:59:59Z`;

  const { data, isLoading, error } = useAuditLogList(filters);

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle>Filtros</CardTitle>
        </CardHeader>
        <CardBody>
          <div className="grid grid-cols-1 sm:grid-cols-4 gap-3">
            <label className="flex flex-col gap-1">
              <span className="text-sm font-medium text-gray-700">Event type</span>
              <input
                className="px-3 py-2 border border-gray-300 rounded-md text-base"
                placeholder="nina.created, rtbf.requested, ..."
                value={eventType}
                onChange={(e) => setEventType(e.target.value)}
              />
            </label>
            <label className="flex flex-col gap-1">
              <span className="text-sm font-medium text-gray-700">Actor email contains</span>
              <input
                className="px-3 py-2 border border-gray-300 rounded-md text-base"
                placeholder="admin@..."
                value={actorEmail}
                onChange={(e) => setActorEmail(e.target.value)}
              />
            </label>
            <label className="flex flex-col gap-1">
              <span className="text-sm font-medium text-gray-700">From</span>
              <input
                type="date"
                className="px-3 py-2 border border-gray-300 rounded-md text-base"
                value={from}
                onChange={(e) => setFrom(e.target.value)}
              />
            </label>
            <label className="flex flex-col gap-1">
              <span className="text-sm font-medium text-gray-700">To</span>
              <input
                type="date"
                className="px-3 py-2 border border-gray-300 rounded-md text-base"
                value={to}
                onChange={(e) => setTo(e.target.value)}
              />
            </label>
          </div>
        </CardBody>
      </Card>

      {isLoading && <div className="text-center py-8 text-gray-600">Cargando…</div>}
      {error && (
        <div className="p-4 bg-red-50 border border-red-200 rounded-md text-red-700" role="alert">
          Error: {error.message}
        </div>
      )}

      {data && (
        <Card>
          <CardBody>
            {data.data.data.length === 0 ? (
              <p className="text-center py-8 text-gray-500">
                Sin eventos para los filtros aplicados.
              </p>
            ) : (
              <table className="w-full text-sm">
                <thead className="border-b border-gray-200">
                  <tr className="text-left">
                    <th className="py-2 font-medium text-gray-700">Timestamp</th>
                    <th className="py-2 font-medium text-gray-700">Event</th>
                    <th className="py-2 font-medium text-gray-700">Actor</th>
                    <th className="py-2 font-medium text-gray-700">Entity</th>
                    <th className="py-2 font-medium text-gray-700">Summary</th>
                  </tr>
                </thead>
                <tbody>
                  {data.data.data.map((entry) => (
                    <tr key={entry.event_id} className="border-b border-gray-100 hover:bg-gray-50">
                      <td className="py-2 text-xs text-gray-500">
                        {entry.occurred_at.slice(0, 19).replace('T', ' ')}
                      </td>
                      <td className="py-2 font-mono text-xs">{entry.event_type}</td>
                      <td className="py-2 text-xs">{entry.actor_email}</td>
                      <td className="py-2 font-mono text-xs">
                        {entry.entity_id ? `${entry.entity_id.slice(0, 10)}…` : '—'}
                      </td>
                      <td className="py-2 text-xs">
                        {entry.summary.length > 80
                          ? `${entry.summary.slice(0, 80)}…`
                          : entry.summary}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            {data.data.has_more && (
              <p className="text-sm text-gray-500 mt-3">
                Hay más resultados. Paginación V2 wired pronto.
              </p>
            )}
          </CardBody>
        </Card>
      )}
    </div>
  );
}
